const userInfo = {}
const isLoading = false
const status = -1
export default {
    userInfo,
    isLoading,
    status
}